import {
  UPDATE_BAZAAR_STALL_DETAILS_FAILURE,
  UPDATE_BAZAAR_STALL_DETAILS_REQUEST,
  UPDATE_BAZAAR_STALL_DETAILS_RESET,
  UPDATE_BAZAAR_STALL_DETAILS_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const updateBazaarStallDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_BAZAAR_STALL_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case UPDATE_BAZAAR_STALL_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case UPDATE_BAZAAR_STALL_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case UPDATE_BAZAAR_STALL_DETAILS_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default updateBazaarStallDetailsReducer
